import conf from './index'

const config = {
  upload: {
    ws_endpoint: `${conf.API_BASE_URL}/me/videos/demo`,
  },
  conf_call: {
    requestId: 'e3bed685-51c6-4128-ba40-f60dabfe6903',
  },
  aws: {
    region: conf.AWS_REGION,
    userPoolId: conf.AWS_USER_POOL_ID,
    userPoolWebClientId: conf.AWS_USER_POOL_WEB_CLIENT_ID,
    refreshSessionUrl: 'https://cognito-idp.eu-west-3.amazonaws.com/',
  },
}

export default config
